import { request } from './apiClient';

export const projectApi = {
  // 프로젝트 목록 (문서 수 포함)
  listProjects: () => request('/projects'),

  // 프로젝트별 문서 목록
  listDocs: (project, { type, search } = {}) => {
    const params = new URLSearchParams();
    if (type) params.set('type', type);
    if (search) params.set('search', search);
    return request(`/projects/${encodeURIComponent(project)}/docs?${params}`);
  },

  // 문서 상세
  getDoc: (project, id) => request(`/projects/${encodeURIComponent(project)}/docs/${id}`),

  // 프로젝트 트리
  getTree: (project) => request(`/projects/${encodeURIComponent(project)}/tree`),

  // 열기 추적
  markOpened: (project, id) => request(`/projects/${encodeURIComponent(project)}/docs/${id}/open`, { method: 'PATCH' }),
};
